// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u7J2","label":"styles_label__1J2HF"};